var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckUnfilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 0.5,
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckUnfilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-unfilled.df65657e7fedb656e899cc9a56ccbe4f.svg";